var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMsPictogram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4041 11.4041H0V-3.05176e-05H11.4041V11.4041Z",
    fill: "#F1511B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9955 11.4041H12.5916V-3.05176e-05H23.9955V11.4041Z",
    fill: "#80CC28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4038 24H0V12.5959H11.4038V24Z",
    fill: "#00ADEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9955 24H12.5916V12.5959H23.9955V24Z",
    fill: "#FBBC09"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsPictogram);
export default __webpack_public_path__ + "static/media/ms-pictogram.6367f514717a8adb38ae64f37bedb494.svg";
export { ForwardRef as ReactComponent };